module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/ShingleColorAndImage-38b7ec6cd7a95462742717df770dbf26.jpg";